import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import { ArchiveNodeOption } from "models/ArchiveNodeOption";

import "./CustomerServiceView.scss";

type Props = {
  fpConfig: any;
  selectedNode: ArchiveNodeOption;
  onSetService: (service: ArchiveNodeOption) => void;
  onSetFpService: (customerChoice: string) => void;
};

export default function CustomerServiceView({
  fpConfig,
  selectedNode,
  onSetService,
  onSetFpService
}: Props) {
  const renderDocumentView = () => {
    return (
      <ul>
        {selectedNode.nodes
          .filter((node) => !node.hidden)
          .map((node) => {
            const hasAllEnabledChildNodes =
              node.nodes.length > 0 && node.nodes.every((serv) => serv.enabled);

            const isEnabled =
              node.enabled || hasAllEnabledChildNodes;
            return (
              <li key={node.id}>
                <div className="foldersWrapper">
                  <input
                    id={node.id}
                    type="checkbox"
                    name={node.name}
                    checked={isEnabled}
                    disabled={node.locked}
                    onChange={() => onSetService(node)}
                  />

                  <label className="d-inline" htmlFor={node.id}>
                    {node.name}
                  </label>
                </div>
              </li>
            );
          })}
      </ul>
    );
  };

  const renderFpView = () => {
    return (
      <ul>
        <li key={selectedNode.id}>
          <div>
            <input
              id={"fp.none"}
              type="radio"
              name={"fp"}
              checked={fpConfig.customerChoice === "Off"}
              onChange={() => onSetFpService("Off")}
            />
            <label htmlFor={"fp.none"}>Av</label>
          </div>
        </li>
        <li key={"fp.month"}>
          <div>
            <input
              id={"fp.month"}
              type="radio"
              name={"fp"}
              checked={fpConfig.customerChoice === "Month"}
              onChange={() => onSetFpService("Month")}
            />
            <label htmlFor={"fp.month"}>Månadsvy</label>
          </div>
        </li>
        <li key={"fp.month.db"}>
          <div>
            <input
              id={"fp.month.db"}
              type="radio"
              name={"fp"}
              checked={fpConfig.customerChoice === "VirtualFarmer"}
              onChange={() => onSetFpService("VirtualFarmer")}
            />
            <label htmlFor={"fp.month.db"}>Månadsvy Digital Bonde</label>
          </div>
        </li>
        <li key={"fp.year"}>
          <div>
            <input
              id={"fp.year"}
              type="radio"
              name={"fp"}
              checked={fpConfig.customerChoice === "Year"}
              onChange={() => onSetFpService("Year")}
            />
            <label htmlFor={"fp.year"}>Årsvy Digital Skogsägare</label>
          </div>
        </li>
      </ul>
    );
  };

  return (
    <div className="serviceView">
      <div className="title">
        <div>{selectedNode.name}</div>
        <InfoIconTooltip text={selectedNode.description} />
      </div>
      {selectedNode.id === "fp" ? renderFpView() : renderDocumentView()}
    </div>
  );
}
